import { render } from "./LoginFormComponent.vue?vue&type=template&id=6a655e00&scoped=true"
import script from "./LoginFormComponent.vue?vue&type=script&lang=js"
export * from "./LoginFormComponent.vue?vue&type=script&lang=js"

import "./LoginFormComponent.vue?vue&type=style&index=0&id=6a655e00&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a655e00"]])

export default __exports__